import React from "react";
import dayjs from "dayjs";
import { Button } from "antd";
import {
  CalendarOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { DEFAULT_DATE_FORMAT } from "@/consts";

interface CustomDateInputProps {
  value: string;
  onClick: () => void;
  onPrev: () => void;
  onNext: () => void;
  hasBorder?: boolean;
}

const customDateInputStyle: React.CSSProperties = {
  alignItems: "center",
  width: "100%",
  display: "flex",
  backgroundColor: "hsl(0, 0%, 100%)",
  borderColor: "hsl(0, 0%, 80%)",
  borderRadius: "4px",
  borderStyle: "solid",
  borderWidth: "1px",
};

const buttonStyle: React.CSSProperties = {
  height: "36px",
  border: "none",
  boxShadow: "none",
  background: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const labelStyle: React.CSSProperties = {
  flex: 1,
  textAlign: "center",
  padding: "0 8px",
  cursor: "pointer",
};

const CustomDateInput = React.forwardRef<
  HTMLInputElement,
  CustomDateInputProps
>(({ value, onClick, onPrev, onNext, hasBorder }, ref) => {
  const today = dayjs().startOf("day");
  const diffDays = today.diff(
    dayjs(value, DEFAULT_DATE_FORMAT).startOf("day"),
    "days"
  );

  let label = value; // Fallback label if not today, tomorrow, or yesterday
  if (diffDays === 0) {
    label = "Today";
  } else if (diffDays === 1) {
    label = "Yesterday";
  } else if (diffDays === -1) {
    label = "Tomorrow";
  }

  return (
    <div style={customDateInputStyle}>
      <Button
        style={buttonStyle}
        disabled={label === "Today"}
        icon={<LeftOutlined />}
        onClick={onPrev}
      />
      <div style={labelStyle} onClick={onClick}>
        <CalendarOutlined style={{ marginRight: 8 }} />
        {label}
      </div>
      <Button style={buttonStyle} icon={<RightOutlined />} onClick={onNext} />
    </div>
  );
});

CustomDateInput.displayName = "CustomDateInput";

export default CustomDateInput;
